import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import css from './ModernLandingPage.module.css';

const items = [
    "Invitation only",
    "Search and sell. Counterparty contacts you directly",
    "Exclusively off-market assets",
    "Principals or direct representatives only",
    "Buy-side and sell-side connect directly",
    "No chains of communication",
    "Vetted members",
    "Modest fee",
];

const listCircle = <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="2" cy="2" r="2" fill="#444444" />
</svg>;

const SectionMission = () => {
    return <div className={css.commonSection}>
        <h3 className={css.missionTitle}>
            <FormattedMessage id="MLP.mission.title" />
        </h3>
        <div className={css.missionContent}>
            {items.map((item, index) => {
                return <div key={index} className={css.missionItem}>
                    {listCircle}
                    {item}
                </div>
            })}
        </div>
    </div>
};

export default SectionMission;
